import React from 'react'

const ConfirmationPage = ({ successText, handleResubmit }) => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="max-w-md text-center p-2 bg-white">
        <h1 className="text-2xl font-semibold ">
          {successText}
        </h1>
        <button
          type="submit"
          className="my-5 mb-5 bg-platinum text-black py-2 px-4 rounded hover:bg-platinum-600 focus:outline-none mx-auto block"
          onClick={handleResubmit}
        >
          Fill Out Another Questionnaire
        </button>
      </div>
    </div>
  )
}

export default ConfirmationPage